import { render, staticRenderFns } from "./ConfirmWaitingAbsenceWidget.vue?vue&type=template&id=27a0f46e&"
import script from "./ConfirmWaitingAbsenceWidget.vue?vue&type=script&lang=js&"
export * from "./ConfirmWaitingAbsenceWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a0f46e')) {
      api.createRecord('27a0f46e', component.options)
    } else {
      api.reload('27a0f46e', component.options)
    }
    module.hot.accept("./ConfirmWaitingAbsenceWidget.vue?vue&type=template&id=27a0f46e&", function () {
      api.rerender('27a0f46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/responsible/planing/absences/widgets/ConfirmWaitingAbsenceWidget.vue"
export default component.exports